import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { SELECT_DATE } from 'common/constants/inputs';
import { useLedgerContext } from 'context/LedgerContext';
import slashedToIsoFormat from 'utilities/slashedToIsoFormat';
import { PurchaseDateSelectProps } from './PurchaseDateSelect.props';

const PurchaseDateSelect = ({ cell, options }: PurchaseDateSelectProps) => {
  const { onCellsChange } = useLedgerContext();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newValue = event.target.value?.toString();
    // find option with same value and convert it to iso format date
    const option = options.find(opt => opt.value === newValue);

    const date = option ? slashedToIsoFormat(option) : '';
    if (option?.value) {
      if (cell) {
        // eslint-disable-next-line no-param-reassign
        cell.acquisition_ref = option.value;
      }
    }
    if (cell) {
      onCellsChange([{ cell, value: date }]);
    }
  };

  const renderFormattedDate = (value: string) => {
    try {
      // Assuming the value is in 'YYYY-MM-DD' format
      return format(parseISO(value), 'MM/dd/yyyy');
    } catch {
      return '';
    }
  };

  return (
    <Select
      variant="standard"
      disableUnderline
      value={cell?.value ?? SELECT_DATE}
      onChange={handleChange}
      renderValue={value => renderFormattedDate(value as string)}>
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default PurchaseDateSelect;
